import React from "react";
import classes from "../styles/style.module.css";
import Bg from "../../../assets/images/Roshana/whyEnrollBg.png";
import QuestionImg from "../../../assets/images/Roshana/questionMark.png";
import DeepReadingImg from "../../../assets/images/Roshana/deepReading.svg";
import MultiDimentioanalImg from "../../../assets/images/Roshana/multiDimentional.png";
import ConsistanceImg from "../../../assets/images/Roshana/continued.png";
import OrganizedImg from "../../../assets/images/Roshana/organized.png";
import LineImg from "../../../assets/images/Roshana/Line.png";

const WhyEnroll = () => {
  return (
    <div className="customContainer">
      <div className={classes.whyEnrollHeader}>
        <img src={Bg} alt="bg" className={classes.bgImage} />
        <div className={classes.headerContainer}>
          <img src={QuestionImg} alt="?" />
          <p>چرا در روشنا شرکت کنیم؟</p>
        </div>
      </div>
      <div className={classes.StepsContainer}>
        <div className={classes.stepContainer}>
          <div className={classes.step}>1</div>
          <div className={classes.stepDetails}>
            <img src={DeepReadingImg} alt="deep reading" />
            <p className={classes.stepDetailsTitle}>عمیق، نه سطحی</p>
            <p className={classes.stepDetailsDesc}>
              در حلقه کتاب ، به خاطر نقد، بحث‌های درون گروهی و گفتگو با نویسنده
              یا مترجم کتاب‌ها، تجربه عمیق‌تری از مطالعه را به دست می‌آوریم.
            </p>
          </div>
        </div>
        <div className={classes.stepContainer}>
          <div className={classes.step}>2</div>
          <div className={classes.stepDetails}>
            <img src={MultiDimentioanalImg} alt="deep reading" />
            <p className={classes.stepDetailsTitle}>چندبعدی، نه تک بعدی</p>
            <p className={classes.stepDetailsDesc}>
              در ‌این حلقه کتاب‌خوانی، برنامه مطالعه کتاب‌ها به صورت روزانه
              برنامه‌ریزی می‌شود؛ و این برنامه انگیزه مهمی برای مطالعه مستمر
              توسط مخاطبان خواهد بود.
            </p>
          </div>
        </div>
        <div className={classes.stepContainer}>
          <div className={classes.step}>3</div>
          <div className={classes.stepDetails}>
            <img src={ConsistanceImg} alt="deep reading" />
            <p className={classes.stepDetailsTitle}>مستمر، نه نامنظم</p>
            <p className={classes.stepDetailsDesc}>
              در ‌این حلقه کتاب‌خوانی‌، کتاب‌های با فرم‌های مختلف از نویسندگان
              داخلی و خارجی، و در ژانرهای متفاوت برای مطالعه انتخاب می‌شوند.
            </p>
          </div>
        </div>
        <div className={classes.stepContainer}>
          <div className={classes.step}>4</div>
          <div className={classes.stepDetails}>
            <img src={OrganizedImg} alt="deep reading" />
            <p className={classes.stepDetailsTitle}>هدفمند، نه بی‌برنامه</p>
            <p className={classes.stepDetailsDesc}>
              در ‌این حلقه کتاب‌خوانی، تلاش می‌شود آثار برجسته ادبیات ایران و
              جهان، با گوشه چشمی به مناسبت‌ها و حوادث روز انتخاب شوند.
            </p>
          </div>
        </div>
        <img src={LineImg} className={classes.line} alt="line" />
      </div>
    </div>
  );
};

export default WhyEnroll;
